import dynamic from 'next/dynamic';

export const TwoLargeFourSmall = dynamic(() => import('./TwoLargeFourSmall'));
export const OneLargeFourSmall = dynamic(() => import('./OneLargeFourSmall'));
export const ThreeImages = dynamic(() => import('./ThreeImages'));
export const FourItems = dynamic(() => import('./FourItems'));
